var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"credential"},[(_vm.showCred == 'login')?_c('Login'):_vm._e(),_vm._v(" "),(_vm.showCred == 'register')?_c('Register'):_vm._e(),_vm._v(" "),(_vm.showCred == 'forgot')?_c('Forgot'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"overlay",on:{"click":_vm.close}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7744cfa2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/Credential.vue
// module id = null
// module chunks = 